import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FileDownloadService {
  constructor() {}

  getFilename(response: HttpResponse<Blob>, name: string = 'filename') {
    const contentDisposition =
      response.headers.get('Content-Disposition') ?? '';

    let filename = name;

    // Сначала пробуем filename*=
    let match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    } else {
      match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        filename = match[1];
      }
    }
    return filename;
  }

  download(response: HttpResponse<Blob>, filename: string) {
    if (response.body) {
      const url = window.URL.createObjectURL(response.body);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Empty response body');
    }
  }
}
